export default "__VITE_ASSET__43KFCC05__"